import { render, staticRenderFns } from "./icon-plus-circle.vue?vue&type=template&id=8a61e6e2"
import script from "./icon-plus-circle.vue?vue&type=script&lang=ts"
export * from "./icon-plus-circle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports